import style from "./paginate.module.css"

function Paginate({ videogamesPage, allVideogames, paginate }) {
	const maxPage = Math.ceil(allVideogames/videogamesPage)
	const pageNumbers = Array.from({length:maxPage},(el,i)=>i+1)

  return (
    <div className={style.container}>
			{
				pageNumbers&&pageNumbers.map( (number) => (
					<button className={`${style.button}`}  key={number} onClick={() => paginate(number)} >{number}</button>
				))
			}
			
    </div>
  )
}

export default Paginate